export const enum DatabasesActionType {
  REFRESH_DATABASES_STARTED = 'REFRESH_DATABASES_STARTED',
  REFRESH_DATABASES_FINISHED = 'REFRESH_DATABASES_FINISHED',

  REFRESH_DATABASE_STARTED = 'REFRESH_DATABASE_STARTED',
  REFRESH_DATABASE_FINISHED = 'REFRESH_DATABASE_FINISHED',

  ADD_MODEL_FILE_TO_DATABASE_STARTED = 'ADD_MODEL_FILE_TO_DATABASE_STARTED',
  ADD_MODEL_FILE_TO_DATABASE_FINISHED = 'ADD_MODEL_FILE_TO_DATABASE_FINISHED',

  CREATE_DATABASE_ATTEMPT = 'CREATE_DATABASE_ATTEMPT',
  CREATE_DATABASE_FAILURE = 'CREATE_DATABASE_FAILURE',
  CREATE_DATABASE_SUCCESS = 'CREATE_DATABASE_SUCCESS',

  REQUEST_DATABASES_ATTEMPT = 'REQUEST_DATABASES_ATTEMPT',
  REQUEST_DATABASES_FAILURE = 'REQUEST_DATABASES_FAILURE',
  REQUEST_DATABASES_SUCCESS = 'REQUEST_DATABASES_SUCCESS',

  REQUEST_DATABASES_INFO_ATTEMPT = 'REQUEST_DATABASES_INFO_ATTEMPT',
  REQUEST_DATABASES_INFO_FAILURE = 'REQUEST_DATABASES_INFO_FAILURE',
  REQUEST_DATABASES_INFO_SUCCESS = 'REQUEST_DATABASES_INFO_SUCCESS',

  REQUEST_DATABASE_DETAILS_ATTEMPT = 'REQUEST_DATABASE_DETAILS_ATTEMPT',
  REQUEST_DATABASE_DETAILS_FAILURE = 'REQUEST_DATABASE_DETAILS_FAILURE',
  REQUEST_DATABASE_DETAILS_SUCCESS = 'REQUEST_DATABASE_DETAILS_SUCCESS',

  UPDATE_DATABASE_DETAILS_ATTEMPT = 'UPDATE_DATABASE_DETAILS_ATTEMPT',
  UPDATE_DATABASE_DETAILS_FAILURE = 'UPDATE_DATABASE_DETAILS_FAILURE',
  UPDATE_DATABASE_DETAILS_SUCCESS = 'UPDATE_DATABASE_DETAILS_SUCCESS',

  REQUEST_DATABASE_NAMESPACES_ATTEMPT = 'REQUEST_DATABASE_NAMESPACES_ATTEMPT',
  REQUEST_DATABASE_NAMESPACES_SUCCESS = 'REQUEST_DATABASE_NAMESPACES_SUCCESS',
  REQUEST_DATABASE_NAMESPACES_FAILURE = 'REQUEST_DATABASE_NAMESPACES_FAILURE',

  IMPORT_DATABASE_NAMESPACES_SUCCESS = 'IMPORT_DATABASE_NAMESPACES_SUCCESS',
  IMPORT_DATABASE_NAMESPACES_FAILURE = 'IMPORT_DATABASE_NAMESPACES_FAILURE',

  BEGIN_DATABASE_TRANSACTION_ATTEMPT = 'BEGIN_DATABASE_TRANSACTION_ATTEMPT',
  BEGIN_DATABASE_TRANSACTION_SUCCESS = 'BEGIN_DATABASE_TRANSACTION_SUCCESS',
  BEGIN_DATABASE_TRANSACTION_FAILURE = 'BEGIN_DATABASE_TRANSACTION_FAILURE',

  COMMIT_DATABASE_TRANSACTION_ATTEMPT = 'COMMIT_DATABASE_TRANSACTION_ATTEMPT',
  COMMIT_DATABASE_TRANSACTION_SUCCESS = 'COMMIT_DATABASE_TRANSACTION_SUCCESS',
  COMMIT_DATABASE_TRANSACTION_FAILURE = 'COMMIT_DATABASE_TRANSACTION_FAILURE',

  ROLLBACK_DATABASE_TRANSACTION_ATTEMPT = 'ROLLBACK_DATABASE_TRANSACTION_ATTEMPT',
  ROLLBACK_DATABASE_TRANSACTION_SUCCESS = 'ROLLBACK_DATABASE_TRANSACTION_SUCCESS',
  ROLLBACK_DATABASE_TRANSACTION_FAILURE = 'ROLLBACK_DATABASE_TRANSACTION_FAILURE',

  ADD_DATA_TO_DATABASE_ATTEMPT = 'ADD_DATA_TO_DATABASE_ATTEMPT',
  ADD_DATA_TO_DATABASE_SUCCESS = 'ADD_DATA_TO_DATABASE_SUCCESS',
  ADD_DATA_TO_DATABASE_FAILURE = 'ADD_DATA_TO_DATABASE_FAILURE',

  CLEAR_DATABASE_NAMED_GRAPH_ATTEMPT = 'CLEAR_DATABASE_NAMED_GRAPH_ATTEMPT',
  CLEAR_DATABASE_NAMED_GRAPH_SUCCESS = 'CLEAR_DATABASE_NAMED_GRAPH_SUCCESS',
  CLEAR_DATABASE_NAMED_GRAPH_FAILURE = 'CLEAR_DATABASE_NAMED_GRAPH_FAILURE',

  CREATE_VIRTUAL_GRAPH_ATTEMPT = 'CREATE_VIRTUAL_GRAPH_ATTEMPT',
  CREATE_VIRTUAL_GRAPH_FAILURE = 'CREATE_VIRTUAL_GRAPH_FAILURE',
  CREATE_VIRTUAL_GRAPH_SUCCESS = 'CREATE_VIRTUAL_GRAPH_SUCCESS',

  UPDATE_VIRTUAL_GRAPH_ATTEMPT = 'UPDATE_VIRTUAL_GRAPH_ATTEMPT',
  UPDATE_VIRTUAL_GRAPH_FAILURE = 'UPDATE_VIRTUAL_GRAPH_FAILURE',
  UPDATE_VIRTUAL_GRAPH_SUCCESS = 'UPDATE_VIRTUAL_GRAPH_SUCCESS',

  IMPORT_CSV_ATTEMPT = 'IMPORT_CSV_ATTEMPT',
  IMPORT_CSV_FAILURE = 'IMPORT_CSV_FAILURE',
  IMPORT_CSV_SUCCESS = 'IMPORT_CSV_SUCCESS',

  REQUEST_NAMED_GRAPHS_ATTEMPT = 'REQUEST_NAMED_GRAPHS_ATTEMPT',
  REQUEST_NAMED_GRAPHS_SUCCESS = 'REQUEST_NAMED_GRAPHS_SUCCESS',
  REQUEST_NAMED_GRAPHS_FAILURE = 'REQUEST_NAMED_GRAPHS_FAILURE',

  LIST_STORED_QUERIES_ATTEMPT = 'LIST_STORED_QUERIES_ATTEMPT',
  LIST_STORED_QUERIES_SUCCESS = 'LIST_STORED_QUERIES_SUCCESS',
  LIST_STORED_QUERIES_FAILURE = 'LIST_STORED_QUERIES_FAILURE',

  CREATE_STORED_QUERY_ATTEMPT = 'CREATE_STORED_QUERY_ATTEMPT',
  CREATE_STORED_QUERY_SUCCESS = 'CREATE_STORED_QUERY_SUCCESS',
  CREATE_STORED_QUERY_FAILURE = 'CREATE_STORED_QUERY_FAILURE',

  UPDATE_STORED_QUERY_ATTEMPT = 'UPDATE_STORED_QUERY_ATTEMPT',
  UPDATE_STORED_QUERY_SUCCESS = 'UPDATE_STORED_QUERY_SUCCESS',
  UPDATE_STORED_QUERY_FAILURE = 'UPDATE_STORED_QUERY_FAILURE',
}
